module.exports = (__webpack_require__(0))(318);


//////////////////
// WEBPACK FOOTER
// delegated ./src/templates/widgets/jsonMetadatumView.pug from dll-reference girder_lib
// module id = 164
// module chunks = 0